import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { DespesasVendedorContext } from '../../context/DespesasVendedorContext';
import { DespesasVendedorType, CreateDespesasVendedorType, UpdateDespesasVendedorType } from '../../context/hooks/useDespesasVendedor';
import useUser from '../../context/hooks/useUser';

const DespesasVendedor = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listDespesasVendedor, despesasVendedorPageCount, getAllDespesasVendedorPaged, createDespesasVendedor, updateDespesasVendedor, deleteDespesasVendedor, aprovarDespesasVendedor, rejeitarDespesasVendedor } = useContext(DespesasVendedorContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [newDespesasVendedor, setNewDespesasVendedor] = useState<CreateDespesasVendedorType>({
        description: "",
        value: 0,
        date: "",
        observation: "",
        empresaId: objUserTk.EmpresaId,
        vendedorId: 0,
        tipoDespesasVendedorId: 0
    });
    const [editingDespesasVendedor, setEditingDespesasVendedor] = useState<UpdateDespesasVendedorType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        description: '',
    });
    const [dataSearch, setDataSearch] = useState({ description: '' });

    useEffect(() => {
        setLoading(true);
        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar despesas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllDespesasVendedorPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ description: '' });
        setLoading(true);
        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewDespesasVendedor(prevDespesasVendedor => ({
            ...prevDespesasVendedor,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateDespesasVendedor = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newDespesasVendedor,
            description: newDespesasVendedor.description,
            value: Number(newDespesasVendedor.value),
            date: newDespesasVendedor.date,
            observation: newDespesasVendedor.observation,
            empresaId: Number(objUserTk.EmpresaId),
            vendedorId: Number(newDespesasVendedor.vendedorId),
        };

        createDespesasVendedor(payload)
            .then(createdDespesasVendedor => {
                if (createdDespesasVendedor) {
                    setCreateModalOpen(false);
                    setNewDespesasVendedor({
                        description: "",
                        value: 0,
                        date: "",
                        observation: "",
                        empresaId: objUserTk.EmpresaId,
                        vendedorId: 0
                    });
                    getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar despesa.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar despesa:", error);
            });
    };

    const handleEditDespesasVendedor = (despesasVendedor: DespesasVendedorType) => {
        setEditingDespesasVendedor(despesasVendedor);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingDespesasVendedor) {
            const updatedData = {
                ...editingDespesasVendedor,
            };
            updateDespesasVendedor(updatedData)
                .then(updatedDespesasVendedor => {
                    if (updatedDespesasVendedor) {
                        setEditModalOpen(false);
                        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                        setEditingDespesasVendedor(null);
                    } else {
                        console.error("Erro ao atualizar despesa.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar despesa:", error);
                });
        }
    };

    const handleDeleteDespesasVendedor = (despesasVendedorId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta despesa?")) {
            deleteDespesasVendedor(despesasVendedorId)
                .then(deletedDespesasVendedor => {
                    if (deletedDespesasVendedor) {
                        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir despesa.");
                    }
                    getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir despesa:", error);
                });
        }
    };

    const getDespesasStatusLabel = (status: number) => {
        switch (status) {
            case 0:
                return "Pendente";
            case 1:
                return "Aprovada";
            case 2:
                return "Rejeitada";
            case 3:
                return "Cancelada";
            default:
                return "Desconhecido";
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Despesas dos vendedores"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                {/* <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por descrição da despesa"
                            value={dataSearch.description}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                </Row> */}

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Descrição</th>
                                        <th>Valores</th>
                                        <th>Data</th>
                                        <th>Status</th>
                                        <th>Categoria</th>
                                        <th>Vendedor</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listDespesasVendedor.map((despesasVendedor: DespesasVendedorType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{despesasVendedor.id}</td>
                                                <td>{despesasVendedor.description}</td>
                                                <td>{(despesasVendedor?.value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{despesasVendedor.date ? new Intl.DateTimeFormat('pt-BR').format(new Date(despesasVendedor.date)) : ""}</td>
                                                <td>
                                                    <span className={`badge ${despesasVendedor.status === 0 ? "bg-warning text-white" :
                                                        despesasVendedor.status === 1 ? "bg-success text-white" :
                                                            despesasVendedor.status === 2 ? "bg-danger text-white" :
                                                                "bg-secondary text-white"
                                                        }`}>
                                                        {getDespesasStatusLabel(Number(despesasVendedor.status))}
                                                    </span>
                                                </td>
                                                <td>{despesasVendedor.tipoDespesasVendedorName ?? "-"}</td>
                                                <td>{despesasVendedor.vendedorName ?? "-"}</td>
                                                <td>
                                                    <Button
                                                        color="success"
                                                        size="sm"
                                                        title="Aprovar"
                                                        onClick={() => {
                                                            aprovarDespesasVendedor(despesasVendedor.id)
                                                                .then(success => {
                                                                    if (success) {
                                                                        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                                                                    } else {
                                                                        console.error("Erro ao aprovar tarefa.");
                                                                    }
                                                                })
                                                                .catch(error => console.error("Erro ao aprovar tarefa:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-thumbs-up me-1"></i> Aprovar
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        title="Rejeitar"
                                                        onClick={() => {
                                                            rejeitarDespesasVendedor(despesasVendedor.id)
                                                                .then(success => {
                                                                    if (success) {
                                                                        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId);
                                                                    } else {
                                                                        console.error("Erro ao rejeitar tarefa.");
                                                                    }
                                                                })
                                                                .catch(error => console.error("Erro ao rejeitar tarefa:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-thumbs-down me-1"></i> Rejeitar
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {despesasVendedorPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={despesasVendedorPageCount}
                                        />
                                    </div>
                                )}
                                {listDespesasVendedor.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as despesas.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </>
    );
};

export default DespesasVendedor;